module.exports = {"620924100":"红柳湾镇","620924200":"阿克旗乡","620924203":"阿勒腾乡","620924204":"阿伊纳乡","620924400":"阿克塞县工业园区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620924.json
// module id = 3075
// module chunks = 0